/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useRef, useState, useContext } from "react";
import { Button, Popover } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { DataGridFilters } from "cms/components/layout/reuse/find-component/dialog/filters/data-grid-filters";
import { ReuseComponentDialogContext } from "cms/components/layout/reuse/find-component/context/index";
import { isArrayNotEmpty } from "utils/empty-exists";

const ComponentFilters = () => {
    
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const filterButtonEl = useRef(null);
    const { filters } = useContext(ReuseComponentDialogContext);
    const filterCount = filters?.length;
    
    const onCloseFilters = () => {
        setFilterPopupOpen(false);
    };
    const onOpenFilters = () => {
        setFilterPopupOpen(true);
    };
    
    return (
        <>
            {/*  Filter Button  */}
            <Button
                ref={filterButtonEl}
                variant='outlined'
                color='neutral'
                size='small'
                startIcon={<FilterAltIcon />}
                onClick={onOpenFilters}
            >
                Filter
                {isArrayNotEmpty(filters) &&
                    <sup>{filterCount}</sup>
                }
            </Button>
            
            {/*   Filter  Controls  */}
            <Popover
                id={"filter-popover"}
                open={filterPopupOpen}
                anchorEl={filterButtonEl.current}
                onClose={onCloseFilters}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <DataGridFilters />
            </Popover>
        
        </>
    );
};

export { ComponentFilters };
